import className from "classnames";
import {
  GOVGR_ARROW__LEFT,
  GOVGR_LINK,
  GOVGR_PAGINATION__ITEM,
  GOVGR_PAGINATION__ITEM__INACTIVE,
  GOVGR_SVG_ICON,
  GOVGR_VISUALLY_HIDDEN,
} from "../../../../../conf/styles/GovGrPagination";
import useLocale from "../../../../../hooks/useLocale";
import { PREVIOUS, RESULTS_SUM, ZERO } from "./paginationPreviousConstants";

const GovGrPaginationPrevious = ({
  currentPage = ZERO,
  onPageChange = ZERO,
}) => {
  const { t } = useLocale();
  let PreviousWrapperClass = className(GOVGR_PAGINATION__ITEM, {
    [GOVGR_PAGINATION__ITEM__INACTIVE]: currentPage === 0,
  });
  let LinkWrapperClass = className(GOVGR_LINK);
  let SpanWrapperClass = className(GOVGR_VISUALLY_HIDDEN);
  let SvgWrapperClass = className(GOVGR_SVG_ICON, GOVGR_ARROW__LEFT);
  const pageChanges = () => {
    if (currentPage > 0) {
      onPageChange({}, currentPage - 1);
    }
  };
  return (
    <li className={PreviousWrapperClass} onClick={pageChanges}>
      <span className={LinkWrapperClass}>
        <svg
          aria-hidden="true"
          className={SvgWrapperClass}
          focusable="false"
          viewBox="0 0 24 24"
        >
          <path d="M14.8,22l2.4-2.3L9.6,12l7.6-7.6L14.8,2l-10,10L14.8,22z" />
        </svg>
        {t(PREVIOUS)}
        <span className={SpanWrapperClass}> {t(RESULTS_SUM)}</span>
      </span>
    </li>
  );
};

export default GovGrPaginationPrevious;
